import apiClient from 'services/axios'

const BASE_URL = 'loyalty'

export async function updateLoyalty(payload) {
  console.log('payload', payload);
  return apiClient
    .put(`${BASE_URL}`, payload)
    .then((response) => ({ response }))
    .catch((error) => ({ error }))
}

export async function getLoyalty() {
  return apiClient
    .get(`${BASE_URL}`)
    .then((response) => ({ response }))
    .catch((error) => ({ error }))
}
